<tt-page *ngIf="!!deviationSourceKeyno">
    <tt-deviation-source [deviationSourceKeyno]="deviationSourceKeyno" (onSave)="onDeviationSourceSave()" (onDelete)="onDeviationSourceDelete()"></tt-deviation-source>
</tt-page>
